import { EmptyState } from "@/admin/ui";

/**
 * Reusable minimal data-table.
 *
 * cols: [{ key, label, render?: (row) => node, className? }]
 * rows: array of objects
 * rowKey: fn (row) => string
 * onRowClick? optional
 */
export default function DataTable({ cols, rows, rowKey, onRowClick, loading, empty }) {
    if (loading) {
        return (
            <div className="rounded-2xl border border-black/5 bg-white p-6">
                <div className="animate-pulse space-y-3">
                    <div className="h-4 w-1/4 bg-neutral-100 rounded" />
                    <div className="h-4 w-3/4 bg-neutral-100 rounded" />
                    <div className="h-4 w-2/3 bg-neutral-100 rounded" />
                    <div className="h-4 w-1/2 bg-neutral-100 rounded" />
                </div>
            </div>
        );
    }
    if (!rows || rows.length === 0) {
        return <EmptyState title={empty?.title || "No records"} hint={empty?.hint} />;
    }
    return (
        <div className="glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-left">
                            {cols.map((c) => (
                                <th
                                    key={c.key}
                                    className={`px-5 py-3 text-[10.5px] font-semibold tracking-[0.16em] uppercase text-neutral-500 ${c.className || ""}`}
                                >
                                    {c.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr
                                key={rowKey(r)}
                                data-testid={`row-${rowKey(r)}`}
                                onClick={onRowClick ? () => onRowClick(r) : undefined}
                                className={`border-t border-black/[0.05] ${onRowClick ? "hover:bg-neutral-50 cursor-pointer" : ""}`}
                            >
                                {cols.map((c) => (
                                    <td
                                        key={c.key}
                                        className={`px-5 py-3.5 align-middle text-neutral-800 ${c.tdClass || ""}`}
                                    >
                                        {c.render ? c.render(r) : (r[c.key] ?? "—")}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
